var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.496,
    height: 17.505,
    viewBox: "0 0 17.496 17.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#faaa3c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M104.644,273.351a6.5,6.5,0,0,1,6.5,6.5h0a6.5,6.5,0,0,1-1.565,4.235l.271.27h.791l5,5-1.5,1.5-5-5v-.79l-.271-.27a6.5,6.5,0,0,1-8.45-9.881h0a6.492,6.492,0,0,1,4.219-1.56m0,2a4.481,4.481,0,1,0,.038,0Z",
    transform: "translate(-98.145 -273.351)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.93e285b29212fd1cae7a1c339644ebfe.svg";
export { ForwardRef as ReactComponent };